module.exports = __webpack_public_path__ + "static/media/sara-01.77059d4f.png";